import React from 'react';
import { MultiSelectList } from 'src/domains/common/components/multi-select-list/multi-select-list';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/AppState/Common';
import { CampaignCreatorState } from 'src/domains/casino/webview/bonus-engine/campaign/CampaignCreator.state';

interface CasinoGamesPickerPropsType {
    campaignId?: string;
    disabled?: boolean;
}

export const CasinoGamesPicker = observer(
    'CasinoGamesPicker',
    ({ campaignId, disabled }: CasinoGamesPickerPropsType): JSX.Element | null => {
        const common = useCommon();
        const gamePickerState = CampaignCreatorState.get(common, campaignId).actionConditionsState.casinoSelectionsState
            .gamePickerState;

        const {
            showAllBadges,
            expanded,
            visibleCheckedWithLabels,
            visibleChecked,
            filteredNodes,
            keywordInputState,
            checked,
            toggleShowAllBadges,
            clearChecked,
            handleCheck,
            handleExpand,
            setKeyword,
            handleRemoveChecked,
        } = gamePickerState;

        return (
            <MultiSelectList
                filteredNodes={filteredNodes}
                showAllBadges={showAllBadges}
                checked={checked}
                visibleChecked={visibleChecked}
                keywordInputState={keywordInputState}
                expanded={expanded}
                visibleCheckedWithLabels={visibleCheckedWithLabels}
                toggleShowAllBadges={toggleShowAllBadges}
                clearChecked={clearChecked}
                handleCheck={handleCheck}
                handleExpand={handleExpand}
                setKeyword={setKeyword}
                handleRemoveChecked={handleRemoveChecked}
                remaining={visibleChecked.remaining}
                remainingLabel='Games'
                disabled={disabled}
            />
        );
    }
);
